import { ReactComponent as Done } from '../../assets/icons/done.svg'

import classes from '../../App.module.scss';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getStoredUserSession, isGuestSession } from '../../assets/utils/utils';

const FinishPage = () => {
    const location = useLocation();
    const session = getStoredUserSession({ clearInvalid: false });
    const isGuest = isGuestSession(session);
    const correctionPending = location.state?.correctionPending === true;

    useEffect(()=>{
        document.title = 'آزمون با موفقیت به پایان رسید';
    },[])

    return (
        <div className={classes.appContainer}>
            <div className={classes.container} style={{alignItems:"center"}}>
                <section className={classes.questionSection} style={{width:"100%"}}>
                    <div className={classes.center}>
                        <Done/>
                    </div>
                    <div className={classes.center}>
                        <h1 className={classes.title}>آزمون شما با موفقیت به اتمام رسید .</h1>
                    </div>
                    {correctionPending && (
                        <div className={classes.center}>
                            <p style={{ maxWidth: 620, textAlign: "center", lineHeight: 1.9, color: "#475569" }}>
                                بخش تستی آزمون ثبت و بررسی شده است. نتیجه نهایی پس از تصحیح سوالات تشریحی توسط ادمین قابل مشاهده خواهد بود.
                            </p>
                        </div>
                    )}
                    {!isGuest && (
                        <div className={classes.center}>
                            <a href='https://panel.roomeet.ir/' target="_self" rel="noreferrer"  className={classes.redirect__btn} >بازگشت به پنل</a>
                        </div>
                    )}
                </section>
            </div>
        </div>
    )
}

export default FinishPage